import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { BriefingApplicationManagerModal } from '@marketing/components'
import CertificateModal from './CertificateModal'

const SOCIALS = [
  {
    key: 'youtube',
    href: 'https://www.youtube.com/channel/UCufMvGtKg2hoTs0h1Ti5cxg',
    icon: '/youtube.svg',
    label: 'YouTube',
  },
  {
    key: 'instagram',
    href: 'https://www.instagram.com/quebon.tv/',
    icon: '/instagram.svg',
    label: 'Instagram',
  },
  {
    key: 'naver-blog',
    href: 'https://blog.naver.com/equalkey',
    icon: '/naver-blog.svg',
    label: 'Naver Blog',
  },
]

export default function BrandFooter() {
  const { t: mt } = useTranslation('marketing')

  const [certOpen, setCertOpen] = useState(false)
  const [manageOpen, setManageOpen] = useState(false)

  const openBizInfo = () => {
    window.open(
      'http://www.ftc.go.kr/bizCommPop.do?wrkr_no=4268700450',
      'bizCommPop',
      'width=750,height=700'
    )
  }

  return (
    <footer className="bg-[#131313] text-[#dadada]">
      <div className="max-w-7xl mx-auto px-6 pt-10 pb-[120px] flex flex-col gap-8">
        {/* Top row: menu + (socials + language toggle) */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <ul className="flex flex-wrap gap-4 md:gap-6 text-base font-semibold tracking-[-0.6px]">
            <li>
              <a
                href="https://www.quebon.tv/about"
                target="_blank"
                rel="noreferrer noopener"
                className="hover:opacity-80 transition-opacity"
              >
                {mt('footer.company')}
              </a>
            </li>
            <li>
              <a
                href="https://quebon.notion.site/36e295b594ac4d44ad2390393f197f13"
                target="_blank"
                rel="noreferrer noopener"
                className="hover:opacity-80 transition-opacity"
              >
                {mt('footer.careers')}
              </a>
            </li>
            <li>
              <button
                type="button"
                onClick={openBizInfo}
                className="hover:opacity-80 transition-opacity"
              >
                {mt('footer.businessInfo')}
              </button>
            </li>
            <li>
              <button
                type="button"
                onClick={() => setManageOpen(true)}
                className="hover:opacity-80 transition-opacity"
              >
                {mt('footer.manageApplication')}
              </button>
            </li>
          </ul>

          <div className="flex items-center gap-3">
            <ul className="flex items-center gap-3">
              {SOCIALS.map((s) => (
                <li key={s.key}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noreferrer noopener"
                    aria-label={s.label}
                    className="w-10 h-10 rounded-xl bg-[#2C2C2C] hover:opacity-80 transition-opacity flex items-center justify-center"
                  >
                    <img src={s.icon} alt="" className="w-6 h-6" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="h-px bg-gray-700" />

        {/* Bottom row: company info + logo */}
        <div className="flex flex-col gap-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-sm text-[#838383] tracking-[-0.6px] leading-relaxed">
            {/* 이쿠얼키(주) */}
            <div className="flex flex-col gap-2">
              <p className="text-[#dadada] font-semibold text-base mb-1">
                {mt('footer.companyName')}
              </p>
              <p>
                <strong className="font-semibold mr-2">{mt('footer.ceo')}
                </strong>{mt('footer.ceoName')}
              </p>
              <p>
                <strong className="font-semibold mr-2">{mt('footer.address')}
                </strong>
                {mt('footer.addressValue')}
              </p>
              <p>
                <strong className="font-semibold mr-2">{mt('footer.businessNumber')}
                </strong>
                426-87-00450
              </p>
              <p>
                <strong className="font-semibold mr-2">
                  {mt('footer.salesNumber')}
                </strong>
                {mt('footer.salesNumberValue')}
              </p>
              <p>
                <strong className="font-semibold mr-2">
                  {mt('footer.academyNumber')}
                </strong>
                {mt('footer.academyNumberValue')}{' '}
                <button
                  type="button"
                  className="text-[#dadada] font-semibold hover:opacity-80 transition-opacity"
                  onClick={() => setCertOpen(true)}
                >
                  {mt('footer.viewDetails')}
                </button>
              </p>
              <p>
                <strong className="font-semibold mr-2">{mt('footer.authority')}
                </strong>
                {mt('footer.authorityValue')}
              </p>
            </div>

            {/* 고객센터 */}
            <div className="flex flex-col gap-2">
              <p className="text-[#dadada] font-semibold text-base mb-1">{mt('footer.support')}
              </p>
              <p>
                <strong className="font-semibold mr-4">{mt('footer.email')}
                </strong>
                info@quebon.com
              </p>
              <p>
                <strong className="font-semibold mr-4">{mt('footer.support')}
                </strong>
                02-562-0701
              </p>
              <p>
                <strong className="font-semibold mr-4">{mt('footer.hours')}
                </strong>
                {mt('footer.hoursValue')}
              </p>
            </div>
          </div>

          <div>
            <img src="/footer-logo.svg" alt="quebon" className="h-7 w-auto" />
            <p className="text-sm text-[#838383] mt-2 tracking-[-0.6px]">
              © 2016 EQUALKEY Co., Ltd. All rights reserved.
            </p>
          </div>
        </div>
      </div>

      <CertificateModal open={certOpen} onClose={() => setCertOpen(false)} />
      <BriefingApplicationManagerModal
        open={manageOpen}
        onOpenChange={setManageOpen}
      />
    </footer>
  )
}
